module.exports = __webpack_public_path__ + "img/39.like.7d8c2726.svg";